import React, { FC } from 'react'
import CaptionLibraryHeader from './CaptionLibraryHeader'
import CaptionList from './CaptionList'
import { PageLayout } from '../System'
import { StyledCaptionLibrary } from '.'

const CaptionLibrary: FC = () => {
  return (
    <PageLayout pageTitle="Caption Library">
      <StyledCaptionLibrary>
        <CaptionLibraryHeader />
        <CaptionList />
      </StyledCaptionLibrary>
    </PageLayout>
  )
}

export default CaptionLibrary
